import Vue from 'vue'
import element from 'element-ui'
import locale from "element-ui/lib/locale/lang/en";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(element, { locale })